import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const generateGradient = (context) => {
    const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, context.chart.height);
    gradient.addColorStop(0, '#FE531F'); // 시작 색상
    gradient.addColorStop(1, '#FFEADE'); // 끝 색상
    return gradient;
};

const AdminMobileVerticalChart = ({ ages }) => {
    // 연령대별 데이터가 있는지 확인
    if (!ages || Object.keys(ages).length === 0) {
        return null; // 데이터가 없을 경우 그래프를 표시하지 않음
    }

    // labels와 dataValues 생성
    const labels = Object.keys(ages);
    const dataValues = Object.values(ages);

    // 최댓값과 그 인덱스 찾기
    const maxValue = Math.max(...dataValues);
    const maxIndex = dataValues.indexOf(maxValue);

    const data = {
        labels,
        datasets: [
            {
                label: '연령 통계(단위 : 명)',
                data: dataValues,
                backgroundColor: (context) => context.dataIndex === maxIndex ? generateGradient(context) : '#FFEADE', // 최댓값의 막대에 그라데이션 적용
            }
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false // 범례 표시
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.dataset.data !== null) {
                            let value = context.dataset.data[context.dataIndex];
                            label += value.toLocaleString() + '명'; // '명' 추가
                        }
                        return label;
                    }
                }
            }
        },
    };

    return <Bar options={options} data={data} />;
};

export default AdminMobileVerticalChart;